export class Opcion {
  public id: number = Math.floor(0);
  public descripcion = '';
  public checked = false;
}
